import { Modal, Stack, Text, Image, Center, Loader } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from './AppLoginQRModal.module.css';

type AppLoginQRModalProps = {
  opened: boolean;
  onClose: () => void;
  qrCodeImage?: string | null;
  loading?: boolean;
};

export default function AppLoginQRModal({ opened, onClose, qrCodeImage, loading }: AppLoginQRModalProps ) {
  const { t } = useTranslation( 'layout' );

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="md"
      centered
      title={t( 'app_login_qr_title', 'Inicio de sesión móvil' )}
      classNames={{ content: classes.modal }}
    >
      <Stack gap="lg" align="center" py="md">
        {loading ? (
          <Center h={300}>
            <Loader size="lg" />
          </Center>
        ) : qrCodeImage ? (
          <>
            <Image
              src={qrCodeImage}
              alt="QR Code for mobile app login"
              w={300}
              h={300}
              fit="contain"
              className={classes.qrImage}
            />
            <Text size="sm" c="dimmed" ta="center">
              {t( 'app_login_qr_description', 'Escanea este código QR con la aplicación móvil de Teselly para iniciar sesión' )}
            </Text>
          </>
        ) : (
          <Text size="sm" c="dimmed" ta="center">
            {t( 'app_login_qr_error', 'No se pudo generar el código QR' )}
          </Text>
        )}
      </Stack>
    </Modal>
  );
}
